<img class="avatar" [src]="src" (error)="setDefaultImage()" [attr.data-src]="src" />
<mat-icon class="primary" *ngIf="isTrustVerified">verified_user</mat-icon>
<mat-icon class="warn" *ngIf="isTrustDangerous">gpp_bad</mat-icon>
